import ErrorPageShell from '@/components/error-page-shell';
import { buttonVariants } from '@/components/ui/button';
import { useSessao } from '@/lib/auth';
import { useTranslation } from '@/lib/i18n';
import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/__authenticated/sem-permissao/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  const { data: usuario } = useSessao();

  // O cliente final (aluno) não pode ver outras páginas, então não faz sentido mostrar
  // o botão de voltar para o dashboard.
  const ehClienteFinal = usuario?.tipo === 'Customer';

  return (
    <ErrorPageShell
      title={t($ => $.errorPage.title)}
      message={t($ => $.mensagemSemPermissaoPagina)}
      button={
        ehClienteFinal ? undefined : (
          <Link to="/dashboard" className={buttonVariants()}>
            {t($ => $.pageNotFound.backHome)}
          </Link>
        )
      }
    />
  );
}
